import Comp from "./Comp";

const Regist = () => {
  return <Comp />;
};

export default Regist;
